import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import '../assets/styles/EarlyAccess.css'; // Reuse the clean design
import '../assets/styles/LandingLayout.css';

const Contact = () => {
  const [copySuccess, setCopySuccess] = useState('');

  const emailAddress = "aimathstutorapp@gmail.com";

  const copyEmailAddress = async () => {
    try {
      await navigator.clipboard.writeText(emailAddress);
      setCopySuccess('Copied!');
      setTimeout(() => setCopySuccess(''), 2000);
    } catch (err) {
      setCopySuccess('Failed to copy');
      setTimeout(() => setCopySuccess(''), 2000);
    }
  };

  return (
    <div className="early-access-page app-background-pattern">
      <div className="early-access-content">
        <div className="hero-section">
          <h1>Get in Touch</h1>
          <p className="hero-subtitle">
            Have <span className="highlight-blue">questions</span> or <span className="highlight-blue">feedback</span>? We'd love to hear from you.
          </p>
        </div>

        <div className="main-content">
          <div className="email-section">
            <h2>Contact Us</h2>
            <p>Send us your questions directly via <span className="highlight-blue">email</span>:</p>
            
            <div className="email-container">
              <div className="email-address" onClick={copyEmailAddress}>
                {emailAddress}
                <button className="copy-btn" aria-label="Copy email address">
                  {copySuccess || '📋'}
                </button>
              </div>
            </div>

            <div className="action-buttons">
              <a href={`mailto:${emailAddress}`} className="primary-btn">
                Send Email
              </a>
              <Link to="/" className="secondary-btn">
                Back to Home
              </Link>
            </div>
          </div>

          <div className="info-section">
            <div className="info-card">
              <h3>What to Include</h3>
              <ul>
                <li>Your name and email</li>
                <li>Clear subject line</li>
                <li>Your question or feedback</li>
                <li>Your role (student/parent/teacher)</li>
                <li>Any relevant details</li>
              </ul>
            </div>
            
            <div className="info-card">
              <h3>Quick Links</h3>
              <ul>
                <li><Link to="/early-access">Request beta access</Link></li>
                <li><Link to="/">Return to homepage</Link></li>
                <li>Check our feature updates</li>
                <li>Report technical issues</li>
                <li>View documentation</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Contact;